import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import {
  CuentaBancariaVes,
  CuentasBancariasVesService,
} from '../../services/cuentas-bancarias-ves.service';
import { CreateCuentaBancariaVesModalComponent } from './create-cuenta-bancaria-ves-modal/create-cuenta-bancaria-ves-modal.component';

@Component({
  selector: 'app-bancos-activos-ves',
  templateUrl: './bancos-activos-ves.component.html',
  styleUrls: ['./bancos-activos-ves.component.sass'],
})
export class BancosActivosVesComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  cuentas: CuentaBancariaVes[] = [];
  expandedCardId: number | null = null;
  displayedColumns: string[] = [
    'titular',
    'rifCedula',
    'banco',
    'tipoCuenta',
    'numeroCuenta',
    'acciones',
  ];

  constructor(
    private cuentasBancariasVesService: CuentasBancariasVesService,
    private dialog: MatDialog,
    private spinner: SpinnerService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.loadCuentas();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  loadCuentas(): void {
    const spinnerRef = this.spinner.start();
    this.subscriptions.add(
      this.cuentasBancariasVesService.getAll().subscribe({
        next: (data) => {
          this.cuentas = data;
          this.spinner.stop(spinnerRef);
        },
        error: () => {
          this.snackBar.open('Error al cargar las cuentas bancarias', 'Ok', {
            duration: 3000,
          });
          this.spinner.stop(spinnerRef);
        },
      })
    );
  }

  openCreateDialog(): void {
    const dialogRef = this.dialog.open(CreateCuentaBancariaVesModalComponent, {
      maxWidth: '95vw',
      minWidth: window.innerWidth < 768 ? '90vw' : '500px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.loadCuentas();
      }
    });
  }

  confirmToggleActive(cuenta: CuentaBancariaVes): void {
    const esActiva = cuenta.activo === 1;
    const accion = esActiva ? 'Desactivar' : 'Activar';
    const iconColor = esActiva ? '#dc2626' : '#16a34a';

    Swal.fire({
      icon: 'question',
      title: `¿${accion} esta cuenta?`,
      html: `
        <p class="mb-2"><b>Titular:</b> ${cuenta.nombreTitular}</p>
        <p class="mb-2"><b>Banco:</b> ${cuenta.banco}</p>
        <p class="mb-2"><b>Cuenta:</b> ${cuenta.numeroCuenta}</p>
        <p class="mt-3">La cuenta pasará a estado <b>${esActiva ? 'INACTIVA' : 'ACTIVA'}</b></p>
      `,
      showCancelButton: true,
      confirmButtonText: `Sí, ${accion.toLowerCase()}`,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: iconColor,
      cancelButtonColor: '#6b7280',
    }).then((result) => {
      if (result.isConfirmed) {
        this.toggleActive(cuenta, esActiva);
      } else {
        this.loadCuentas();
      }
    });
  }

  private toggleActive(cuenta: CuentaBancariaVes, esActiva: boolean): void {
    const spinnerRef = this.spinner.start();
    this.subscriptions.add(
      this.cuentasBancariasVesService
        .toggleActive(cuenta.cuentaBancariaVesId)
        .subscribe({
          next: () => {
            this.spinner.stop(spinnerRef);
            Swal.fire({
              icon: 'success',
              title: `Cuenta ${esActiva ? 'desactivada' : 'activada'}`,
              html: `<p><b>${cuenta.nombreTitular}</b> - ${cuenta.banco}</p>`,
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.loadCuentas();
          },
          error: (err) => {
            this.spinner.stop(spinnerRef);
            const msg =
              typeof err === 'string' ? err : 'Error al cambiar el estado';
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: msg,
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
          },
        })
    );
  }

  toggleCard(id: number): void {
    this.expandedCardId = this.expandedCardId === id ? null : id;
  }
}
